var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBox
    ? _c(
        "sc-card",
        { staticClass: "page-logs-tracking-event-header-order" },
        [
          _c("template", { attrs: { slot: "header" }, slot: "header" }, [
            _c(
              "h2",
              { staticClass: "has-text-primary is-size-4 card-header-title" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.event.orders.length) +
                    " Pedido(s)\n    "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "template",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c(
                "sc-carousel",
                {
                  staticClass:
                    "page-logs-tracking-event-header-order__orders-slider",
                  attrs: { options: _vm.sliderOrdersOptions }
                },
                [
                  _vm._l(_vm.event.orders, function(order) {
                    return _c(
                      "sc-carousel-slide",
                      {
                        key: order.shipment_order_number,
                        staticClass:
                          "page-logs-tracking-event-header-order__orders-slider-slide"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "page-logs-tracking-event-header-order__orders-slider-slide-item"
                          },
                          [
                            order.shipment_order_number
                              ? _c(
                                  "p",
                                  { staticClass: "heading" },
                                  [
                                    _c("strong", [_vm._v("Número do pedido:")]),
                                    _vm._v(" "),
                                    _c(
                                      "sc-tooltip",
                                      {
                                        attrs: { label: "Visualizar o pedido" }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "ng#/order-number/" +
                                                order.shipment_order_number +
                                                "/",
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  order.shipment_order_number
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            order.volumes.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "page-logs-tracking-event-header-order__volumes-card"
                                  },
                                  [
                                    _c(
                                      "h2",
                                      {
                                        staticClass:
                                          "page-logs-tracking-event-header-order__volumes-card-title has-text-primary is-size-5 has-text-centered"
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(order.volumes.length) +
                                            " Volume(s)\n            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "sc-carousel",
                                      {
                                        ref: "volumes",
                                        refInFor: true,
                                        staticClass:
                                          "page-logs-tracking-event-header-order__volumes-slider",
                                        attrs: {
                                          options: _vm.sliderVolumesOptions
                                        }
                                      },
                                      [
                                        _vm._l(order.volumes, function(volume) {
                                          return _c(
                                            "sc-carousel-slide",
                                            { key: volume.volume_number },
                                            [
                                              volume.volume_number
                                                ? _c(
                                                    "p",
                                                    { staticClass: "heading" },
                                                    [
                                                      _c("strong", [
                                                        _vm._v("Volume:")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            volume.volume_number
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              volume.invoice_number
                                                ? _c(
                                                    "p",
                                                    { staticClass: "heading" },
                                                    [
                                                      _c("strong", [
                                                        _vm._v("Nota fiscal:")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            volume.invoice_number
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("strong", [
                                                        _vm._v("Série:")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            volume.invoice_serie
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              volume.invoice_key
                                                ? _c(
                                                    "p",
                                                    { staticClass: "heading" },
                                                    [
                                                      _c("strong", [
                                                        _vm._v("Chave da nota:")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            volume.invoice_key
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              volume.tracking_code
                                                ? _c(
                                                    "p",
                                                    { staticClass: "heading" },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          "Código de rastreamento:"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            volume.tracking_code
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "page-logs-tracking-event-header-order__volumes-slider__button-prev",
                                            attrs: { slot: "button-prev" },
                                            slot: "button-prev"
                                          },
                                          [
                                            _c("sc-icon", {
                                              attrs: { icon: "chevron-left" }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "page-logs-tracking-event-header-order__volumes-slider__button-next",
                                            attrs: { slot: "button-next" },
                                            slot: "button-next"
                                          },
                                          [
                                            _c("sc-icon", {
                                              attrs: { icon: "chevron-right" }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "page-logs-tracking-event-header-order__orders-slider__button-prev",
                      attrs: { slot: "button-prev" },
                      slot: "button-prev"
                    },
                    [_c("sc-icon", { attrs: { icon: "chevron-up" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "page-logs-tracking-event-header-order__orders-slider__button-next",
                      attrs: { slot: "button-next" },
                      slot: "button-next"
                    },
                    [_c("sc-icon", { attrs: { icon: "chevron-down" } })],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3faf4058", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3faf4058","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/pages/logs-tracking-detail/components/sc-logs-tracking-detail-header/blocks/sc-logs-tracking-detail-header-order/ScLogsTrackingDetailHeaderOrder.vue
// module id = null
// module chunks = 